import { MarketplaceRecipient } from 'api/session/types/recipient.interface';
import { sessionApiService } from 'api/session/session.api.service';

export const createMarketplaceRecipient = async (
  data: MarketplaceRecipient,
): Promise<MarketplaceRecipient> => {
  const res = await sessionApiService
    .updateMarketplaceRecipients(data)
    .catch((e: Error) => {
      throw new Error(`Error: ${e.message}`);
    });
  return res.data;
};

export const cleanMarketplaceRecipient = async (): Promise<void> => {
  await sessionApiService.cleanMarketplaceRecipients();
};
